var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { InfoModalComponent } from "app/views/modal/info_modal.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { HelperService } from "../../../lib/helper.service";
var FriendDetailsComponent = /** @class */ (function (_super) {
    __extends(FriendDetailsComponent, _super);
    function FriendDetailsComponent(activeModal, helper) {
        var _this = _super.call(this, activeModal) || this;
        _this.activeModal = activeModal;
        _this.helper = helper;
        return _this;
    }
    FriendDetailsComponent.prototype.ok = function () {
        this.close();
    };
    return FriendDetailsComponent;
}(InfoModalComponent));
export { FriendDetailsComponent };
